<template>
  <div>
    <!-- For Assignment -->
    <div>
      <div
        class="light-border p-4 my-2"
        v-for="(eachQuestion, index) in QuestionModal"
        :key="index"
      >
        <!-- <pre>{{eachQuestion}}</pre> -->

        <div v-if="eachQuestion">

          <p class="question-container">{{ eachQuestion.questions.title }}</p>

          <div class="points_holder" v-if="assignment_type_id !== 3">
            <label for="points">
              <span
                v-if="
                  (eachQuestion.answers.assignment_question_answer_id === null || eachQuestion.answers.assignment_question_answer_id.length === 0) 
                  && (!eachQuestion.answers.short_answer || eachQuestion.answers.short_answer === null)
                  && eachQuestion.answers.files.length === 0 
                  && assignment_type_id !== 3
                "
              >
                <img
                  style="width: 15px; position: relative; top: 2px"
                  src="../../../../assets/images/warning-emoji.png"
                />
                <span
                  style="
                  font-size: 12px;
                  color: red;
                  box-shadow: 0px 0px 2px grey;
                  border-radius: 10px;
                  padding: 0px 3px;
                  margin-left: 5px;
                  margin-right: 5px;
                  "> No answer found 
                </span>
              </span>
              <b> Points:</b>
            </label>

            <!-- {{eachQuestion.answers}} -->
          
            <vs-input 
              type="number"
              v-model="eachQuestion.answers.mark" 
              min="0"
              :max="eachQuestion.questions.point" 
              v-on:keyup="updateTotalSubtotal(eachQuestion, assignment_type_id, $event.target)"
              @change="updateTotalSubtotal(eachQuestion, assignment_type_id, $event.target)"
              :disabled="
                (eachQuestion.answers.assignment_question_answer_id === null || eachQuestion.answers.assignment_question_answer_id.length === 0) 
                && (!eachQuestion.answers.short_answer || eachQuestion.answers.short_answer === null)
                && eachQuestion.answers.files.length === 0 
                && assignment_type_id !== 3
              "
            >
            </vs-input>

           <label for="points" class="max-point-label"><b> of </b>{{eachQuestion.questions.point}}</label>

          </div>

          <vs-divider/>

          <vs-textarea
            v-if="
              eachQuestion.questions.question_input_type_id === 1 ||
              eachQuestion.questions.question_input_type_id === 2
            "
            label="Write your answer here"
            v-model="eachQuestion.answers.short_answer"
            :disabled="assignment_type_id !== 3"

          />

          <LinkPreviewComponent :question_detail="eachQuestion">
          </LinkPreviewComponent>

          <div
            v-if="eachQuestion.questions.question_input_type_id === 3"
          >
            <div
              class="options-holder"
              v-for="(options, index) in eachQuestion.questions.questions_options"
              :key="index"
            >
                <!-- {{eachQuestion.answers}} -->
                <vs-radio
                v-model="eachQuestion.answers.assignment_question_answer_id"
                :name="`custom${index}`"
                :vs-value="options.id"
                :disabled="assignment_type_id !== 3"
                >{{ options.option_name }}
                <!-- {{options.id}} -->
                </vs-radio
              >
            </div>
          </div>

          <div
            v-if="eachQuestion.questions.question_input_type_id === 5"
          >
            <v-select
              class="mb-5"
              v-model="eachQuestion.answers.assignment_question_answer_id"
              :name="`custom${index}`"
              :disabled="assignment_type_id !== 3"
              :options="eachQuestion.questions.questions_options"
              :reduce="option => option.id"
              label="option_name"
            />
          </div>

        <div
          v-if="
            eachQuestion.questions.question_input_type_id === 4 ||
            eachQuestion.questions.question_input_type_id === 6
          "
        >
          <div
            class="options-holder"
            v-for="(options, index) in eachQuestion.questions.questions_options"
            :key="index"
          >
            <!-- {{eachQuestion.answers}} -->
            <vs-checkbox 
              v-model="eachQuestion.answers.assignment_question_answer_id" 
              :name="`custom${index}`"
              :vs-value="options.id"
              :disabled="assignment_type_id !== 3">
              {{
              options.option_name
              }}
            <!-- {{options.id}} -->
            </vs-checkbox>
            <br>
          </div>
        </div>
        
        <!-- Question type File Uplaod - Start-->
         <div v-if="eachQuestion.questions.question_input_type_id === 7">
            <vs-card v-if="eachQuestion.answers.files.length">
              <h5>&#9929; Uploaded Files
                  <span style="color:green;font-size:10px !important">(Click to download)</span>
              </h5>
              <vs-divider/>

              <div
                class="flex flex-wrap items-center"
              >
                <div
                  class="m-4"
                  v-for="(eachFile, eachFileIndex) in eachQuestion
                    .answers.files"
                  :key="eachFileIndex"
                >

                  <div
                    class="file-container"
                    :href="eachFile.file_path"
                    @click.prevent="downloadFile(eachFile)"
                  >
                    <!-- <span>{{++eachFileIndex}}. </span> -->
                    <!-- <p style="color:black">{{eachFile.file_type}}</p> -->

                    <vs-card
                      class="mb-0 upload_card_content"
                      style="min-height: 172px;"
                      v-if="eachFile.file_type.includes('image')"
                    >
                      <img
                        class="object-contain w-full"
                        :src="eachFile.file_path"
                      />
                      <p style="color:gray">{{ eachFile.file_name }}</p>
                    </vs-card>

                    <vs-card
                      class="mb-0 upload_card_content"
                      style="min-height: 172px;"
                      v-else-if="eachFile.file_type.includes('audio')"
                    >
                      <audio class="w-full" controls>
                        <source
                          :src="eachFile.file_path"
                          :type="eachFile.file_type"
                        />
                        Your browser does not support the audio element.
                      </audio>
                      <p style="color:gray">{{ eachFile.file_name }}</p>
                    </vs-card>

                    <vs-card
                      class="mb-0 upload_card_content"
                      style="min-height: 172px;"
                      v-else-if="eachFile.file_type.includes('video')"
                    >
                      <video class="w-full" controls>
                        <source
                          :src="eachFile.file_path"
                          :type="eachFile.file_type"
                        />
                        Your browser does not support the audio element.
                      </video>
                      <p style="color:gray">{{ eachFile.file_name }}</p>
                    </vs-card>

                    <vs-card
                      class="mb-0 upload_card_content"
                      style="min-height: 172px;"
                      v-else-if="eachFile.file_type.includes('application/pdf')"
                    >
                      <i
                        class="material-icons"
                        style="color: teal;"
                        >picture_as_pdf</i
                      >
                      <p style="color:gray">{{ eachFile.file_name }}</p>
                    </vs-card>

                    <vs-card
                      class="mb-0 upload_card_content"
                      style="min-height: 172px;"
                      v-else-if="eachFile.file_type.includes('doc')"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        width="40"
                        height="40"
                        viewBox="0 0 172 172"
                        style="fill: #000000"
                      >
                        <g
                          fill="none"
                          fill-rule="nonzero"
                          stroke="none"
                          stroke-width="1"
                          stroke-linecap="butt"
                          stroke-linejoin="miter"
                          stroke-miterlimit="10"
                          stroke-dasharray=""
                          stroke-dashoffset="0"
                          font-family="none"
                          font-weight="none"
                          font-size="none"
                          text-anchor="none"
                          style="mix-blend-mode: normal"
                        >
                          <path d="M0,172v-172h172v172z" fill="none"></path>
                          <g fill="#9b59b6">
                            <path
                              d="M86,21.5l-71.66667,14.33333v100.33333l71.66667,14.33333zM100.33333,35.83333v14.33333h43v14.33333h-43v14.33333h43v14.33333h-43v14.33333h43v14.33333h-43v14.33333h50.16667c3.956,0 7.16667,-3.21067 7.16667,-7.16667v-86c0,-3.956 -3.21067,-7.16667 -7.16667,-7.16667zM23.61361,59.44694h11.00195l3.52734,24.92937c0.25083,1.49783 0.44657,3.5382 0.50391,6.06087h0.18197c0.05733,-1.84183 0.31869,-3.94335 0.75586,-6.20085l4.52116,-24.78939h13.39551l4.18522,24.70541c0.25083,1.29716 0.42955,3.20361 0.61589,5.66894h0.13997c0.05733,-1.9135 0.24624,-3.89923 0.48991,-5.94889l3.42936,-24.42546h10.34408l-9.91016,53.10612h-9.42025l-6.29883,-28.38672c-0.31533,-1.77017 -0.48823,-3.76307 -0.5599,-5.9489h-0.12598c-0.129,2.38651 -0.37771,4.37223 -0.68587,5.9489l-6.4248,28.38672h-9.79818z"
                            ></path>
                          </g>
                        </g>
                      </svg>
                      <p style="color:gray">{{ eachFile.file_name }}</p>
                    </vs-card>

                    <vs-card
                      class="mb-0 upload_card_content"
                      style="min-height: 172px;"
                      v-else-if="eachFile.file_type.includes('text')"
                    >
                      <!-- <img
                        src="data:image/png;base64,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"
                      /> -->
                      <svg xmlns="http://www.w3.org/2000/svg" width="53" height="58" viewBox="0 0 53 58" fill="none">
                        <path d="M28.5 1.75H6.5C5.04131 1.75 3.64236 2.32946 2.61091 3.36091C1.57946 4.39236 1 5.79131 1 7.25V51.25C1 52.7087 1.57946 54.1076 2.61091 55.1391C3.64236 56.1705 5.04131 56.75 6.5 56.75H39.5C40.9587 56.75 42.3576 56.1705 43.3891 55.1391C44.4205 54.1076 45 52.7087 45 51.25V18.25L28.5 1.75Z" fill="#6D808E"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.90381 2.65381C3.12279 1.43482 4.77609 0.75 6.5 0.75H28.5C28.7652 0.75 29.0196 0.855357 29.2071 1.04289L45.7071 17.5429C45.8946 17.7304 46 17.9848 46 18.25V51.25C46 52.9739 45.3152 54.6272 44.0962 55.8462C42.8772 57.0652 41.2239 57.75 39.5 57.75H6.5C4.77609 57.75 3.12279 57.0652 1.90381 55.8462C0.684819 54.6272 0 52.9739 0 51.25V7.25C0 5.52609 0.684819 3.87279 1.90381 2.65381ZM6.5 2.75C5.30653 2.75 4.16193 3.22411 3.31802 4.06802C2.47411 4.91193 2 6.05653 2 7.25V51.25C2 52.4435 2.47411 53.5881 3.31802 54.432C4.16193 55.2759 5.30653 55.75 6.5 55.75H39.5C40.6935 55.75 41.8381 55.2759 42.682 54.432C43.5259 53.5881 44 52.4435 44 51.25V18.6642L28.0858 2.75H6.5Z" fill="#6D808E"/>
                        <path d="M45.2929 18.2929L28.7785 1.77853C28.1388 1.13878 27.046 1.60982 27.0718 2.5142L27.5437 19.0286C27.5591 19.5695 28.0021 20 28.5433 20H44.5858C45.4767 20 45.9229 18.9229 45.2929 18.2929Z" fill="#E4F3FF"/>
                        <rect x="14" y="27" width="39" height="16" rx="3" fill="#E4F3FF"/>
                        <path d="M26.0143 31V32.7313H23.5834V40H21.4056V32.7313H19V31H26.0143Z" fill="#6D808E"/>
                        <path d="M29.092 32.7313V34.6153H32.1181V36.2574H29.092V38.256H32.4979V40H26.9269V31H32.4979V32.7313H29.092Z" fill="#6D808E"/>
                        <path d="M39.1591 40L37.2726 37.1994L35.6519 40H33.1703L36.0318 35.3663L33.0817 31H35.6519L37.4878 33.7115L39.0705 31H41.5394L38.716 35.5318L41.7294 40H39.1591Z" fill="#6D808E"/>
                        <path d="M49 31V32.7313H46.569V40H44.3913V32.7313H41.9857V31H49Z" fill="#6D808E"/>
                      </svg>
                      <p style="color:gray">{{ eachFile.file_name }}</p>
                    </vs-card>

                    <vs-card class="mb-0 upload_card_content" style="min-height: 172px;" v-else>
                      <!-- {{ eachFile.file_name }} -->
                      <i
                        class="material-icons"
                        style="color: teal;"
                        >assignment</i
                      >
                      <p style="color:gray">{{ eachFile.file_name }}</p>
                    </vs-card>

                    <!-- <span>{{eachFile.file_name}}</span> -->
                    <!-- <span><i> - Download</i></span> -->
                  </div>
                </div>
              </div>
            </vs-card>
            
            <vs-card v-else>
              <h4>No files found</h4>
            </vs-card>
         </div>
         <!-- Question type File Uplaod - End-->
        
        <!-- <p><b>Feedback : </b> {{ eachQuestion.feedback }}</p> -->
        <!-- {{ eachQuestion.links }} -->
      <div>
        <!-- {{eachQuestion.answers.teacher_comment}} -->
        <vs-textarea 
          label="Feedback" 
          v-model="eachQuestion.answers.teacher_comment"
          :disabled="
            (eachQuestion.answers.assignment_question_answer_id === null || eachQuestion.answers.assignment_question_answer_id.length === 0) 
            && (!eachQuestion.answers.short_answer || eachQuestion.answers.short_answer === null) 
            && eachQuestion.answers.files.length === 0 
            && assignment_type_id !== 3
          "
        />
      </div>
        
      </div>
      </div>
    </div>
  </div>
</template>

<script>
//courses ->type:1, Lesson->type:2, Topics->3
import LinkPreviewComponent from './LinkPreviewComponent'
import vSelect from 'vue-select'
import {EventBus} from '../mixin/EventBus'
import axios from 'axios'
axios.defaults.withCredentials = true

export default {
  name: 'QuestionModal',
  props: {
    QuestionModal: {
      type: Array,
      required: true,
      default: () => {}
    },
    Modaltype: {
      type: String,
      required: true,
      default: 'Question'
    },
    lessonId:{
      type:Number,
      default:null
    },
    course_id:{
      type:Number,
      default:null
    },
    sectionType:{
      type:Number,
      default:null
    },
    platform_customer_id:{},
    assignment_type_id:{
      type:Number,
      default:0
    }
  },
  mixins: [EventBus],
  components: {
    LinkPreviewComponent,
    vSelect
    
  },
  data () {
    return {
      testingrad: ''
      // answers:[]
    }
  },
  created () {

    if (this.Modaltype == 'Question') {
      this.setQuestionModalAnswer()
    } else {
      this.setQuestionAssignmentAnswer()
    }
    this.QuestionModal.forEach((value) => {
      //console.log(value)
      value.answers.mark = Number(value.answers.mark)
      if (value.answers.files === undefined || !value.answers.files.length) {
        value.answers.files = []
        
        if (value.answers.assignment_question_answer_id === undefined || value.answers.assignment_question_answer_id === null || value.answers.assignment_question_answer_id === '') {
          //value.answers.assignment_question_answer_id = []
          this.$set(value.answers, 'assignment_question_answer_id', [])
        }

        value.answers.files_demo = [
          {
            'id': 2512,
            'files_repository_id': 2340,
            'file_name': 'test-img (5).png',
            'file_path': 'https://scoolio-files.s3.ap-south-1.amazonaws.com/20210310100828335907/Default/s0TxddbEz675sTKJ.png',
            'uploaded_on': '2021-06-14T06:23:37.000000Z',
            'size': 12183,
            'file_type': 'image/png',
            'created_at': '2021-06-14T06:23:37.000000Z',
            'updated_at': '2021-06-14T06:23:37.000000Z',
            'deleted_at': null,
            'pivot': {
              'user_course_answer_id': 335,
              'file_id': 2512,
              'id': 1
            }
          },
          {
            'id': 2512,
            'files_repository_id': 2340,
            'file_name': 'test-img (5).png',
            'file_path': 'https://scoolio-files.s3.ap-south-1.amazonaws.com/20210310100828335907/Default/s0TxddbEz675sTKJ.png',
            'uploaded_on': '2021-06-14T06:23:37.000000Z',
            'size': 12183,
            'file_type': 'image/png',
            'created_at': '2021-06-14T06:23:37.000000Z',
            'updated_at': '2021-06-14T06:23:37.000000Z',
            'deleted_at': null,
            'pivot': {
              'user_course_answer_id': 335,
              'file_id': 2512,
              'id': 1
            }
          }
        ]
      }
    })
  },
  mounted () {
  },
  methods: {
    downloadFile ({ file_path, file_name, file_type }) {
      axios.get(file_path, { responseType: 'blob' })
        .then(response => {
          const blob = new Blob([response.data], { type: file_type })
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = file_name
          link.click()
          URL.revokeObjectURL(link.href)
        }).catch(console.error)
    },
    getMaxAllowedMarks (initial_max_from_api) {
      const max_allowed = Number(initial_max_from_api) + 0 
      return max_allowed
    },
    updateTotalSubtotal (eachQuestion, assignment_type_id, target) {
      // console.log('Target', target)
      const value = target.value
      const maxValue = eachQuestion.questions.point
      if (value > maxValue) {
        this.$vs.notify({
          title: 'Error',
          text: `Maximum allowed marks is ${   Number(maxValue)}`,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          time: 3000
        })
        
        target.value = null
        eachQuestion.answers.mark = null
        
        EventBus.$emit('updateGradeSummary', {
          assignment_type_id,
          'value':Number(value)
        })
       
      } else {
        EventBus.$emit('updateGradeSummary', {
          assignment_type_id,
          'value':Number(value)
        })
      }
    },
    showingNotImplemented () {
      alert('Not Yet Implemented')
    },
    answerQuestionSubmit () {
      
      let payload = []
      if (this.Modaltype == 'Question') {
        payload = this.QuestionModal.map((ele) => {
          return {
            course_id:this.course_id,
            lesson_id: this.lessonId,
            type: this.sectionType,
            course_assignment_or_question_id: ele.id,
            question_bank_question_answer_id:
            ele.Questiontype === 'radio' ? [ele.answer] : ele.answer,
            question_type: 2, // question bank
            short_answer: ele.short_answer,
            Questiontype: ele.Questiontype
          }
        }).filter((ele) => {
          if (ele.Questiontype == 'radio' || ele.Questiontype == 'checkbox') {
            return ele.question_bank_question_answer_id.length > 0
          } else {
            return ele.short_answer !== null
          }
        })
      } else {
        payload = this.QuestionModal.map((ele) => {
          return {
            course_id:this.course_id,
            lesson_id: this.lessonId,
            type: this.sectionType,
            assignment_question_id: ele.id,
            assignment_question_answer_id:
            ele.Questiontype === 'radio' ? [ele.answer] : ele.answer,
            question_type: 1, //assignment
            short_answer: ele.short_answer,
            Questiontype: ele.Questiontype
          }
        }).filter((ele) => {
          if (ele.Questiontype == 'radio' || ele.Questiontype == 'checkbox') {
            return ele.assignment_question_answer_id.length > 0
          } else {
            return ele.short_answer !== null
          }
        })
      }

      
      if (payload.length) {
        this.saveAnswerQuestion(payload)
      }
    },
    async saveAnswerQuestion (payload) {
      try {
        
        const answers = {
          answers: payload,
          platform_customer_id:this.platform_customer_id
        }
        
        const data = await SubmitAnswer(answers)
        
        let successMessage = ''
        if (this.Modaltype == 'Question') {
          successMessage = 'Question Answer Saved successfully'
        } else {
          successMessage = 'Assignmnent Answer Saved Successfully'
          
        }
        this.$vs.notify({
          title: 'Success',
          text: `${successMessage}`,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 3000
        })
      } catch (error) {
        
        this.$vs.notify({
          title: 'error',
          text: 'Something Went Wrong',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          time: 3000
        })
      }
    },
    getAnswerId (ele) {
      
      if (ele.Questiontype === 'radio') {
        if (ele.answer == null) {
          return []
        }
      } else {
        return ele.answer
      }
    },
    setQuestionModalAnswer () {
      this.QuestionModal.forEach((ele) => {
        if (
          ele.questions.question_input_type_id == '3' ||
          ele.questions.question_input_type_id == '5'
        ) {
          
          this.$set(
            ele,
            'answer',
            ele.answers !== null
              ? ele.answers.question_bank_question_answer_id[0]
              : null
          )
          this.$set(ele, 'short_answer', null)
          ele.Questiontype = 'radio'
        } else if (
          ele.questions.question_input_type_id == '4' ||
          ele.questions.question_input_type_id == '6'
        ) {
          // this.$set(ele, 'answer', [])
          this.$set(
            ele,
            'answer',
            ele.answers !== null
              ? ele.answers.question_bank_question_answer_id
              : []
          )

          this.$set(ele, 'short_answer', null)

          ele.Questiontype = 'checkbox'
        } else {
          this.$set(
            ele,
            'short_answer',
            ele.answers !== null
              ? ele.answers.short_answer
              : null
          )
          // this.$set(ele, 'short_answer', null)
          ele.Questiontype = 'shortanswer'
        }
      })
    },
    setQuestionAssignmentAnswer () {
      this.QuestionModal.forEach((ele) => {
        
        if (
          ele.question_input_type_id == '3' ||
          ele.question_input_type_id == '5'
        ) {
          
          this.$set(
            ele,
            'answer', ele.answers !== null ? ele.answers.assignment_question_answer_id[0] : null
          )
          this.$set(ele, 'short_answer', null)
          ele.Questiontype = 'radio'
        } else if (
          ele.question_input_type_id == '4' ||
          ele.question_input_type_id == '6'
        ) {
          // this.$set(ele, 'answer', [])
          this.$set(
            ele, 'answer', ele.answers !== null ? ele.answers.assignment_question_answer_id : [])

          this.$set(ele, 'short_answer', null)

          ele.Questiontype = 'checkbox'
        } else {
          this.$set(
            ele,
            'short_answer',
            ele.answers !== null
              ? ele.answers.short_answer
              : null
          )
          // this.$set(ele, 'short_answer', null)
          ele.Questiontype = 'shortanswer'
        }
      })
    }
  }
}
</script>

<style scoped>
.points_holder{
  float:right;
}

.points_holder label{
  float:left;
  margin-right: 10px;
  margin-top: 10px;
}

.points_holder .vs-con-input-label{
  display: inline-block;
  width:65px;
}

.points_holder .max-point-label{
  float:none !important;
}

.file-container{
  display: inline-block;
  background: rebeccapurple;
  color: white;
  padding: 6px 12px;
  border-radius: 30px;
  box-shadow: 0px 0px 5px #0000003d;
}
</style>